/**
 * No need to translate currencies
 */
export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  JPY = 'JPY',
  GBP = 'GBP',
  CHF = 'CHF',

  // Above are G5 currencies

  AED = 'AED',
  AUD = 'AUD',
  BAM = 'BAM',
  BGN = 'BGN',
  BHD = 'BHD',
  BRL = 'BRL',
  CAD = 'CAD',
  CLP = 'CLP',
  CNH = 'CNH',
  CNY = 'CNY',
  COP = 'COP',
  CZK = 'CZK',
  DKK = 'DKK',
  EGP = 'EGP',
  HKD = 'HKD',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  ISK = 'ISK',
  JOD = 'JOD',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LKR = 'LKR',
  MAD = 'MAD',
  MKD = 'MKD',
  MXN = 'MXN',
  MYR = 'MYR',
  NAD = 'NAD',
  NOK = 'NOK',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  SAR = 'SAR',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  TND = 'TND',
  TRY = 'TRY',
  TWD = 'TWD',
  VND = 'VND',
  ZAR = 'ZAR',
  ZWL = 'ZWL',
}

/**
 * Currencies that we need to handle its subunit in fx rate for stocks and funds
 */
export enum CurrencyWithSubunit {
  GBP = 'GBp',
}

/**
 * Returns currency symbols (WAA-4946) given a Currency.
 *
 * Note: This is a bad idea in general, we should use the native currency formatting APIs to format our numbers.
 * @param ccy
 */
export function getCurrencySymbol(ccy: Currency = Currency.USD): string {
  switch (ccy) {
    case Currency.USD:
      return '$';
    case Currency.EUR:
      return '€';
    case Currency.JPY:
      return '¥';
    case Currency.GBP:
      return '£';
  }
  // In all other cases, just return the currency code verbatim
  return ccy as string;
}
